import React, { Suspense } from 'react'

const PayPageBase = React.lazy(() => import('./Pay'))

export const PayPage = () => (
  <Suspense fallback={null}>
    <PayPageBase />
  </Suspense>
)
